import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("DocumentGroupInput")
export class DocumentGroupInput {
    @JsonProperty("mediaId", String, true)
    public mediaId?: string = JsonPropertyEmpty;

    public constructor(args?: Partial<DocumentGroupInput>) {
        Object.assign(this, args);
    }
}
